module.exports = __webpack_public_path__ + "img/issue-icon17.4e2deca.png";